import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { cn } from "../utils/styling";
import { Icon, IconProps } from "./Icon";
import { IconButton, IconButtonProps } from "./IconButton";

const sharedClassNames = "h-6 w-6 justify-center rounded-sm border-2 border-solid bg-lds-surface-bright";

export const SuccessCheckmark = ({ className }: { className?: string }) => {
  const borderColorClassName = `border-[var(--color-purpose-status-positive)]`;
  return (
    <Stack className={cn(sharedClassNames, borderColorClassName, className)}>
      <SuccessCheckmarkIcon />
    </Stack>
  );
};

export const SuccessCheckmarkIcon = () => (
  <Icon color="var(--color-purpose-status-positive)" iconName="Checkmark" size="md" />
);

export const ErrorCross = ({ className }: { className?: string }) => {
  const color = "var(--color-purpose-status-negative-subtle)";
  const borderColorClassName = `border-[var(--color-purpose-status-negative-subtle)]`;
  return (
    <Stack className={cn(sharedClassNames, borderColorClassName, className)}>
      <Icon color={color} iconName="Close" svgClassName="h-4 w-4" />
    </Stack>
  );
};

export const PendingText = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <span className={cn("text-lds-purpose-status-negative-subtle font-ds-body-semibold-sm", className)}>
      {t("general.pending")}
    </span>
  );
};

export const TrashIcon = ({
  buttonProps,
  iconProps,
}: Omit<IconButtonProps, "iconProps"> & { iconProps?: Omit<IconProps, "color" | "iconName"> | undefined }) => (
  <IconButton
    buttonProps={{
      className: "h-8 w-8",
      variant: "tertiary",
      ...(buttonProps ?? {}),
    }}
    iconProps={{
      color: "var(--color-purpose-status-negative-subtle)",
      iconName: "Trash",
      size: "md",
      ...(iconProps ?? {}),
    }}
  />
);
